import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";

function EOIModal(props) {
  const { t } = useTranslation('translation', {keyPrefix: 'eoi'});

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header style={{ backgroundColor: "#282878" }}>
          <Modal.Title>
            <h2 style={{ color: "#ffffff" }}>{t('title')}</h2>
          </Modal.Title>
          <Modal.Title>
            <button type="button" className="close" aria-label="Close" style={{color:"white"}} onClick={props.handleClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <embed style={{width:"100%", height:"640px"}} src='https://embed.referral-factory.com/MUHGWc/join'></embed>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-sm btn-outline-dark mr-3 ml-auto"
            onClick={props.handleClose}
          >
            {t('closeWindow')}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default EOIModal;
